
































import { Component, Prop, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import { Blog } from '@/resource/blog/blog.model';

@Component({
  components: { MainButton },
})
export default class BlogBanner extends Vue {
  @Prop()
  blog: Blog;

  async bannerClick() {
    this.$sendMpEvent({
      event: this.$mp_value.BlogBannerClick,
      properties: {
        uuid: this.blog.uuid ? this.blog.uuid : '',
        title: this.blog.title,
      },
    });

    this.$router.push({
      name: 'browse',
    });
  }
}
